import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { http } from "@/lib/api";
import FoncierClair from "@/pages/FoncierClair";
import Synthesis from "@/pages/Synthesis";
import PaymentReturn from "@/pages/PaymentReturn";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";

function Gate() {
  const { gateToken } = useParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    if (!gateToken || !gateToken.startsWith("FC-")) {
      setState("nope");
      return;
    }
    http
      .get(`/gate/${gateToken.slice(3)}`)
      .then(() => setState("ok"))
      .catch(() => setState("nope"));
  }, [gateToken]);
  if (state === "loading") return <div className="min-h-screen bg-background" />;
  if (state === "nope") return <NotFound />;
  return <FoncierClair />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NotFound />} />
          <Route path="/:gateToken" element={<Gate />} />
          <Route path="/synthesis/:id" element={<Synthesis />} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
